"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchCondition = _interopRequireDefault(require("01_core/components/layout/SearchCondition"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _authorityUtil = _interopRequireDefault(require("01_core/logics/authorityUtil"));
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _SelectAreaMaster = _interopRequireDefault(require("../../common/components/SelectAreaMaster"));
var _SelectKaisha = _interopRequireDefault(require("../../common/components/SelectKaisha"));
var _siteOrderingActions = require("../siteOrderingActions");
var _useRHFForm = require("01_core/validation/useRHFForm");
var Yup = _interopRequireWildcard(require("yup"));
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 拠点表示順設定検索条件コンポーネント
 */
function SiteOrderingSearchCondition(props) {
  var _searchConditions$kai, _searchConditions$are, _errors$kaishaCd, _errors$areaCd;
  const {
    intl,
    callAPI,
    openInfoBar,
    changeSearchCondition,
    changeInitSearchCondtion,
    setSearchResult,
    resetPaging,
    setIsReSearch,
    searchConditions,
    fixedConditions,
    isReSearch,
    search,
    isNewWindow,
    loginUserInfo,
    pms,
    initCondtionComplete
  } = props;
  const areaRef = _react.default.useRef(null);
  const PERMISSIONS = _react.default.useMemo(() => ({
    KAISHASOSHIKI_SELECT_ALL: 'kaishasoshiki:select:all_kaisha'
  }), []);

  // 会社必須か（権限により切替）
  const isSetNone = _authorityUtil.default.hasPermission(pms, PERMISSIONS.KAISHASOSHIKI_SELECT_ALL);
  const requireKaisha = !isSetNone;

  // Yup スキーマ
  const schema = _react.default.useMemo(() => Yup.object({
    kaishaCd: requireKaisha ? (0, _validationHelpers.requiredSelect)(intl) : Yup.string().nullable(),
    areaCd: Yup.string().nullable()
  }), [requireKaisha, intl]);
  const {
    handleSubmit,
    setValue,
    reset,
    formState: {
      errors
    }
  } = (0, _useRHFForm.useRHFForm)({
    shape: schema,
    defaultValues: {
      kaishaCd: (_searchConditions$kai = searchConditions.kaishaCd) !== null && _searchConditions$kai !== void 0 ? _searchConditions$kai : '',
      areaCd: (_searchConditions$are = searchConditions.areaCd) !== null && _searchConditions$are !== void 0 ? _searchConditions$are : ''
    }
  });

  // 画面初期化相当（初回：会社名をログインユーザ会社で初期化）
  _react.default.useEffect(() => {
    if (search) {
      // 初期表示で検索指示がある場合
      // submit（RHFのonSubmit）でハンドリングする
    }
    if (!initCondtionComplete) {
      changeInitSearchCondtion('kaishaCd', loginUserInfo.kaishaCd);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Redux -> RHF 同期（検索条件が外部で変わったときにRHf側へ反映）
  _react.default.useEffect(() => {
    var _searchConditions$kai2, _searchConditions$are2;
    reset({
      kaishaCd: (_searchConditions$kai2 = searchConditions.kaishaCd) !== null && _searchConditions$kai2 !== void 0 ? _searchConditions$kai2 : '',
      areaCd: (_searchConditions$are2 = searchConditions.areaCd) !== null && _searchConditions$are2 !== void 0 ? _searchConditions$are2 : ''
    });
  }, [searchConditions.kaishaCd, searchConditions.areaCd, reset]);

  // 再検索フラグON時は再検索を実行
  _react.default.useEffect(() => {
    if (isReSearch) {
      onValid();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReSearch]);

  // 会社変更時に地域を未選択へ
  const prevKaishaCdRef = _react.default.useRef(searchConditions.kaishaCd);
  _react.default.useEffect(() => {
    if (prevKaishaCdRef.current !== searchConditions.kaishaCd) {
      changeSearchCondition('areaCd', '');
      setValue('areaCd', '', {
        shouldValidate: false,
        shouldDirty: false
      });
      prevKaishaCdRef.current = searchConditions.kaishaCd;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchConditions.kaishaCd]);

  // 検索実行
  const onValid = () => {
    let conditions = _objectSpread({}, searchConditions);
    if (!search) {
      resetPaging();
    }
    if (isReSearch) {
      var _conditions$kaishaCd;
      // 並び順変更後の再検索の場合
      conditions = _objectSpread({}, fixedConditions);
      changeSearchCondition('kaishaCd', conditions.kaishaCd);
      setValue('kaishaCd', (_conditions$kaishaCd = conditions.kaishaCd) !== null && _conditions$kaishaCd !== void 0 ? _conditions$kaishaCd : '', {
        shouldValidate: false,
        shouldDirty: false
      });
    }
    callAPI(_APIs.SITE_ORDERING_SEARCH, conditions).then(json => {
      if (Array.isArray(json.data.results) && json.data.results.length > 0) {
        setSearchResult(json.data.results);
        if (areaRef.current) {
          _windowUtil.default.scrollBelowElement(areaRef.current);
        }
      } else {
        setSearchResult([]);
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
          id: _labelConsts.LABEL.CORE_NO_SEARCH_RESULT_MESSAGE
        }));
      }
      setIsReSearch(false);
    });
  };
  const onInvalid = () => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  };

  // 地域選択変更時
  const onChangeArea = obj => {
    var _obj$areaCd;
    changeSearchCondition('areaCd', obj.areaCd);
    setValue('areaCd', (_obj$areaCd = obj.areaCd) !== null && _obj$areaCd !== void 0 ? _obj$areaCd : '', {
      shouldValidate: false,
      shouldDirty: false
    });
  };

  // 会社選択変更時
  const onChangeKaisha = _ref => {
    let {
      kaishaCd
    } = _ref;
    changeSearchCondition('kaishaCd', kaishaCd);
    setValue('kaishaCd', kaishaCd !== null && kaishaCd !== void 0 ? kaishaCd : '', {
      shouldValidate: false,
      shouldDirty: false
    });
  };

  // 検索条件
  const conditions = [/*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_COMPANY
    })
  }, /*#__PURE__*/_react.default.createElement(_SelectKaisha.default, {
    onChange: onChangeKaisha,
    value: searchConditions.kaishaCd,
    isSetNone: isSetNone,
    error: !!errors.kaishaCd,
    helperText: (_errors$kaishaCd = errors.kaishaCd) === null || _errors$kaishaCd === void 0 ? void 0 : _errors$kaishaCd.message
  })), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.MASTERDATA_AREA
    })
  }, /*#__PURE__*/_react.default.createElement(_SelectAreaMaster.default, {
    value: searchConditions.areaCd,
    kaishaCd: searchConditions.kaishaCd,
    onAreaSiteChange: onChangeArea,
    error: !!errors.areaCd,
    helperText: (_errors$areaCd = errors.areaCd) === null || _errors$areaCd === void 0 ? void 0 : _errors$areaCd.message
  }))];
  const closeBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => {
      window.close();
    },
    negative: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CLOSE
  }));
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: areaRef
  }, isNewWindow ? /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
    conditions: conditions,
    validate: true,
    cancelBtn: closeBtn
  }) : /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
    conditions: conditions,
    validate: true,
    returnHome: true
  })), search && /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    style: {
      display: 'none'
    },
    "aria-hidden": "true"
  }));
}
const mapStateToProps = state => {
  return {
    searchConditions: state.siteOrdering.searchConditions,
    fixedConditions: state.siteOrdering.fixedConditions,
    isReSearch: state.siteOrdering.isReSearch,
    search: state.siteOrdering.search,
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    initCondtionComplete: state.siteOrdering.initCondtionComplete
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (key, value) => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    changeInitSearchCondtion: (key, value) => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.CHANGE_INIT_SEARCH_CONDITION](key, value)),
    setSearchResult: results => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.SET_SEARCH_RESULT](results)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    resetPaging: () => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.RESET_PAGING]()),
    setIsReSearch: isReSearch => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.SET_IS_RE_SEARCH](isReSearch))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(SiteOrderingSearchCondition))));